/**
 * Import Swiper bundle
 */
import Swiper from 'swiper/bundle';


/**
 * Init Swiper
 */
$(function() {
    var swiperSliders = document.querySelectorAll('.swiper-template');

    swiperSliders.forEach(slider => {
        let swiperOptions = {},
            swiperSliderClasses = slider.className,
            swiperSliderMode = swiperSliderClasses.match('swiper-fade'),
            swiperSliderIndicatorMode = swiperSliderClasses.match(/swiper-indicator-(\w+)/),
            swiperSliderFullscreen = swiperSliderClasses.match('swiper-fullscreen'),
            swiperSliderItems = swiperSliderClasses.match(/swiper-items-(\d)-(\d)-(\d)/),
            swiperSliderGutter = swiperSliderClasses.match(/swiper-gutter-(\d+)/),
            swiperSliderSlideBy = swiperSliderClasses.match('swiper-slide-page'),
            swiperSliderItemCenter = swiperSliderClasses.match('swiper-item-center'),
            swiperSliderLoop = swiperSliderClasses.match('swiper-loop'),
            swiperSliderNav = swiperSliderClasses.match('swiper-nav'),
            swiperSliderDots = swiperSliderClasses.match('swiper-dots'),
            swiperSliderSpeed = swiperSliderClasses.match(/swiper-speed-(\d+)/),
            swiperSliderAutoplaySpeed = swiperSliderClasses.match(/swiper-autoplay-speed-(\d+)/),
            swiperSliderAutoplayPause = swiperSliderClasses.match('swiper-autoplay-pause');

        // Default parameters
        swiperOptions = {
            loop: (swiperSliderLoop ? true : false),
            slidesPerView: parseInt(swiperSliderItems[1]),
            centeredSlides: (swiperSliderItemCenter ? true : false),
            spaceBetween: (swiperSliderGutter ? parseInt(swiperSliderGutter[1]) : 0),
            speed: (swiperSliderSpeed ? parseInt(swiperSliderSpeed[1]) : 300),
            lazy: true,
            // Responsive breakpoints
            breakpoints: {
                768: {
                    slidesPerView: parseInt(swiperSliderItems[2]),
                },
                992: {

                },
                1200: {
                    slidesPerView: parseInt(swiperSliderItems[3]),
                }
            },
        }

        // Mode
        if (swiperSliderMode) {
            swiperOptions.effect = 'fade'
            swiperOptions.fadeEffect = {
                crossFade: true
            }
        }

        // Autoplay
        if (swiperSliderAutoplaySpeed) {
            swiperOptions.autoplay = {
                delay: (swiperSliderAutoplaySpeed ? parseInt(swiperSliderAutoplaySpeed[1]) : 3000),
                disableOnInteraction: false,
            }
        }

        // Slides per group
        if (swiperSliderSlideBy) {
            swiperOptions.slidesPerGroup = parseInt(swiperSliderItems[1])
            swiperOptions.breakpoints = {
                768: {
                    slidesPerView: parseInt(swiperSliderItems[2]),
                    slidesPerGroup: parseInt(swiperSliderItems[2]),
                },
                992: {

                },
                1200: {
                    slidesPerView: parseInt(swiperSliderItems[3]),
                    slidesPerGroup: parseInt(swiperSliderItems[3]),
                }
            }
        }

        // Pagination
        if (swiperSliderDots) {
            swiperOptions.pagination = {
                el: '.swiper-pagination',
                clickable: true,

                type: 'bullets',
            }

            if (swiperSliderIndicatorMode[1] === 'dpoints') {
                swiperOptions.pagination.dynamicBullets = true
            }
            if (swiperSliderIndicatorMode[1] === 'strips') {
                swiperOptions.pagination.bulletClass = 'swiper-pagination-strip'
                swiperOptions.pagination.bulletActiveClass = 'swiper-pagination-strip-active'
            }
        }

        // Navigation arrows
        if (swiperSliderNav) {
            swiperOptions.navigation = {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        }

        const swiper = new Swiper(slider, swiperOptions);
    });

    const swiper = new Swiper('.swiperslideshow', {
        speed: 400,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    });


        var swipergallery = new Swiper('.gallery', {
            loop: true,
            spaceBetween: 95,
            slidesPerView: 'auto',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

    var museen = new Swiper('.museenswiper', {
        slidesPerView: 1,
        loop:true,
        spaceBetween: 30,
        navigation: {
            nextEl: '.swiper-button-nexta',
            prevEl: '.swiper-button-preva',
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
            },
            992: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 4,
            }
        },
    });
});

